import './overlay';
import $ from "jquery";
import * as Popover from 'bootstrap/js/dist/popover';

document.addEventListener('DOMContentLoaded', function () {
  Sceon.LatestActions = {
    limit: 15,
    offset: 0,
    url: '/latest-actions',
  };

  Sceon.HashController = {
    _current: '',

    init: function () {
      window.onhashchange = function () {
        Sceon.HashController.check();
      };
      Sceon.HashController.check();
    },

    check: function () {
      let hash = document.location.hash.substring(1);

      if (hash !== this._current) {
        this._current = hash;

        let filter = Sceon.LatestActions.ParseHash();

        Sceon.LatestActions.Load(filter);
      }
    },
  };

  Sceon.LatestActions.Load = function (filter) {
    let lc_overlay = new Sceon.Overlay($('.latest-actions-container'), {
      loader: '/imgr/loader-tiny.gif',
      offset: {bottom: 0, top: 0},
    });

    lc_overlay.enable();

    if (filter.name) {
      filter.name = filter.name.replace(/%20/g, ' ');
    }
    setTimeout(function () {
      $.ajax({
        url: Sceon.LatestActions.url,
        method: 'GET',
        data: filter,
        success: function (resp) {
          $('.latest-actions-container').html(resp);
          lc_overlay.disable();
          Sceon.LatestActions.initPopover();
        },
        error: function (err) {
          console.error(err);
          lc_overlay.disable();
        },
      });
    }, 100);

    $('html, body').animate(
      {
        scrollTop: 0,
      },
      700,
    );
  };

  Sceon.LatestActions.InitFilterChange = function () {
    setTimeout(() => {
      document.querySelectorAll('.sort-select').forEach((select) => {
        select.onchange = function () {
          if (event) {
            Sceon.LatestActions.SetHash(Sceon.LatestActions.MakeHash());
          }
        };
      });
    }, 50);
  };

  Sceon.LatestActions.Paginate = function (page) {
    Sceon.LatestActions.SetHash(
      Sceon.LatestActions.MakeHash({ page }),
    );
  };

  Sceon.LatestActions.GetFilters = function (params = {}) {
    let filters = {};
    $(document)
      .find('.latest-actions-filter select:not(:disabled)')
      .each((ind, el) => {
        let val = $(el).val();
        if (val?.length && val != 'null') {
          filters[$(el).attr('name')] = val;
        }
      });

    filters = {
      ...filters,
      ...params,
    };

    return filters;
  };

  Sceon.LatestActions.SetFiltersFromHash = function () {
    let hash = location.hash.substring(1);
    if (hash.length > 0) {
      let objs = hash.split(';');
      objs.forEach((el) => {
        let name = el.split('=')[0];
        let val = el.split('=')[1];

        if (val) {
          val = val.replace(/%20/g, ' ');
        }

        if (name && val) {
          $(`[name=${name}]`).val(decodeURI(val));
          if ($(`[name=${name}]`).hasClass('sort-select')) {
            $(`[name=${name}]`).trigger('change');
          }
        }
      });
    }
  };

  Sceon.LatestActions.ParseHash = function () {
    let hash = location.hash.substring(1);
    let filter = {};
    if (!hash.length) {
      return {};
    }
    let params = hash.split(';');
    for (let i in params) {
      let name = params[i].split('=')[0];
      let val = params[i].split('=')[1];
      if (name && val) {
        filter[name] = val;
      }
    }
    return filter;
  };

  Sceon.LatestActions.MakeHash = function (params = {}) {
    let filter = Sceon.LatestActions.GetFilters(params);
    let hash = '';
    for (let i in filter) {
      hash += `${i}=${filter[i]};`;
    }
    return hash;
  };

  Sceon.LatestActions.SetHash = function (hash) {
    if (hash.length) {
      document.location.hash = '#' + hash;
    } else {
      document.location.hash = '';
    }
    return false;
  };

  Sceon.LatestActions.initPopover = function () {
    const actions = document.querySelectorAll('.action-escort-item');

    actions.forEach(e => {
      const popoverHtml = $(e).find('.custom-popover-container').html();

      let popoverOptions = {
        content: function () {
          return popoverHtml;
        },
        trigger: 'click',
        container: 'body',
        animation: false,
        placement: 'top',
        html: true,
        customClass: 'action-popover'
      };

      let p = new Popover(e, popoverOptions);
      e.addEventListener('hidden.bs.popover', function () {
        $('.modal-backdrop').remove();
      });
      e.addEventListener('show.bs.popover', function (pop) {
        $('<div class="modal-backdrop"></div>').appendTo(document.body);
        $('.modal-backdrop').on('click', function (b) {
          b.preventDefault();
          p.hide();
          $('.modal-backdrop').remove();
        });
        $(document).on('click', '.close-popover',function(e) {
          e.preventDefault();
          p.hide();
        });
      })
    });
  };

  Sceon.LatestActions.ListTypeChanges = function () {
    $('.list-types a').on('click', function (e) {
      e.preventDefault();
      let mode = $(this).attr('data-mode');

      function escortsPageList(mode) {
        Sceon.setPageCookie('la_list_type', mode);
        $('.latest-actions')
          .removeClass('xl-view grid-view list-view')
          .addClass(mode + '-view');
        $('.list-types').attr('class', 'list-types ' + mode + '-view');
      }

      escortsPageList(mode);

      $('.escorts-list .profile-photo').each(function (index, el) {
        const url = $(el)
          .attr('src')
          .replace(/thumb_\d+/i, mode === 'xl' ? 'thumb_420' : 'thumb_298');
        $(el).attr('src', url);
      });
    });

    function changeGrid() {
      if (
        window.innerWidth < 769 &&
        document
          .querySelector('.latest-actions')
          ?.classList.contains('xl-view')
      ) {
        document
          .querySelector('.list-types a[data-mode="grid"]')
          .dispatchEvent(new Event('click'));
      }
    }

    changeGrid();
    window.addEventListener('resize', () => {
      changeGrid();
    });
  };

  Sceon.LatestActions.ListTypeChanges();
  Sceon.LatestActions.InitFilterChange();
  Sceon.LatestActions.SetFiltersFromHash();
  Sceon.LatestActions.initPopover();
  Sceon.HashController.init();
});
